export default [
  {
    path: "/merge-transfers",
    component: () => import(/* webpackChunkName: "payins" */ "./layout"),

    children: [
      {
        path: "/",
        name: "merge-transfers.index",
        component: () => import(/* webpackChunkName: "payins" */ "./index"),
      },
      {
        props: true,
        path: ":id",
        name: "merge-transfers.show",
        component: () => import(/* webpackChunkName: "payins" */ "./show"),
      },
    ],
  },
];
